import {useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {ModalSize, SimpleModal} from "../../SimpleModal";
import Form, {FormInitValuesType} from "../../Form";
import {isNotEmpty, validateEmail} from "../../../utils/validation";
import {Col, Row, Title2} from "../../../styles/components";
import {Button} from "../../Button";

import * as S from './styles'

import BetaTestImage from "../../../assets/images/ab_beta_test_image.png";


const initValues: FormInitValuesType = {
    fio: {value: '', validationCheck: isNotEmpty},
    teleGuardId: {value: '', validationCheck: isNotEmpty},
    email: {value: '', validationCheck: validateEmail},
    device: {value: '', validationCheck: isNotEmpty},
    system: {value: '', validationCheck: isNotEmpty},
    country: {value: '', validationCheck: isNotEmpty},
    numberContacts: {value: '', validationCheck: isNotEmpty},
    comment: {value: '', validationCheck: isNotEmpty},
    terms: {value: false, validationCheck: val => !!val}
}

export const BetaTest = () => {
    const [show, setShow] = useState(false);
    const showModal = () => setShow(true);
    const closeModal = () => setShow(false);

    const intl = useIntl();

    return (
        <S.Container>
            <S.Content>
                <div>
                    <S.Image src={BetaTestImage}/>
                </div>
                <S.TextBlock>
                    <S.Title><FormattedMessage id="aboutBetaTestTitle"/></S.Title>
                    <S.Text><FormattedMessage id="aboutBetaTestText1"/></S.Text>
                    <Button onClick={showModal}><FormattedMessage id="aboutBetaTestButton1"/></Button>
                </S.TextBlock>

                <SimpleModal show={show} close={closeModal} modalSize={ModalSize.medium}>
                    <S.ModalBody>
                        <Title2><FormattedMessage id="aboutBetaTestModalTitle"/></Title2>
                        <S.ModalSubText><FormattedMessage id="aboutBetaTestModalText1"/></S.ModalSubText>

                        <Form initValues={initValues} apply={data => alert(JSON.stringify(data))}>
                            {
                                ({data, setValue, isValid, onSubmit}) => {
                                    return (
                                        <div>
                                            <Form.Input
                                                name={'fio'}
                                                placeholder={intl.formatMessage({id: 'aboutBetaTestModalFIO'})}
                                                data={data}
                                                setValue={setValue}
                                                isValid={isValid['fio']}
                                                hint={intl.formatMessage({id: 'aboutBetaTestModalFIOHint'})}
                                            />

                                            <Row>
                                                <Col xl={5}>
                                                    <Form.Input
                                                        name={'teleGuardId'}
                                                        placeholder={'TeleGuard ID'}
                                                        data={data}
                                                        setValue={setValue}
                                                        isValid={isValid['teleGuardId']}
                                                    />
                                                </Col>
                                                <Col xl={6} xlOffset={1}>
                                                    <Form.Input
                                                        name={'email'}
                                                        placeholder={intl.formatMessage({id: 'aboutBetaTestModalMail'})}
                                                        data={data}
                                                        setValue={setValue}
                                                        isValid={isValid['email']}
                                                        hint={intl.formatMessage({id: 'aboutBetaTestModalMailHint'})}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col xl={5}>
                                                    <Form.Input
                                                        name={'device'}
                                                        placeholder={intl.formatMessage({id: 'aboutBetaTestModalDevice'})}
                                                        data={data}
                                                        setValue={setValue}
                                                        isValid={isValid['device']}
                                                    />
                                                </Col>
                                                <Col xl={6} xlOffset={1}>
                                                    <Form.Input
                                                        name={'system'}
                                                        placeholder={intl.formatMessage({id: 'aboutBetaTestModalSystem'})}
                                                        data={data}
                                                        setValue={setValue}
                                                        isValid={isValid['system']}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col xl={5}>
                                                    <Form.Input
                                                        name={'country'}
                                                        placeholder={intl.formatMessage({id: 'aboutBetaTestModalCountry'})}
                                                        data={data}
                                                        setValue={setValue}
                                                        isValid={isValid['country']}
                                                    />
                                                </Col>
                                                <Col xl={6} xlOffset={1}>
                                                    <Form.Input
                                                        name={'numberContacts'}
                                                        placeholder={intl.formatMessage({id: 'aboutBetaTestModalNumberContacts'})}
                                                        data={data}
                                                        setValue={setValue}
                                                        isValid={isValid['numberContacts']}
                                                    />
                                                </Col>
                                            </Row>

                                            <Form.TextArea
                                                name={'comment'}
                                                placeholder={intl.formatMessage({id: 'aboutBetaTestModalComment'})}
                                                data={data}
                                                setValue={setValue}
                                                isValid={isValid['comment']}
                                            />

                                            <S.ModalTerms>
                                                <Form.CheckBox name={'terms'} data={data} setValue={setValue}/>
                                                Я согласен с тем, что мои данные будут обрабатываться и использоваться
                                                только для ответа, обработки и выполнения запроса. Данные будут храниться и
                                                обрабатываться только до тех пор, пока этого требует обработка сообщения.
                                                Данные не будут переданы третьим лицам. Я согласен с политикой конфиденциальности.
                                            </S.ModalTerms>

                                            <br/>

                                            <Form.Submit onClick={onSubmit}>ОТПРАВИТЬ ЗАЯВКУ</Form.Submit>
                                        </div>
                                    );
                                }
                            }
                        </Form>
                    </S.ModalBody>
                </SimpleModal>
            </S.Content>
        </S.Container>
    )
}